import { BaseEntity } from 'yt-ng-framework';
import { stringify } from 'querystring';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
//import { StaticInjector } from '@angular/core/src/di/injector';

export class StrucnoUsavrsavanjeView extends BaseEntity {
  constructor(){
      super();
  }

OsobaPrezimeIIme : string;
TipPotvrdeOStrucnomUsavrsavanjuNaziv : string;
TipStrucnogUsavrsavanjaNaziv : string;
Naziv : string;
Predavac : string;
Trajanje : number;
Datum : NgbDate;
RealizovanOdDatuma : NgbDate;
RealizovanDoDatuma : NgbDate;
BrojBodova : number;
KataloskiBroj : number;
Mesto : string;
USvojstvuPredavaca : boolean;
Obavezno : boolean;


Deserialize(input: any){
  this.ID = input.ID;
  this.OsobaPrezimeIIme = input.Osoba;
  this.TipPotvrdeOStrucnomUsavrsavanjuNaziv = input.TipPotvrdeOStrucnomUsavrsavanju;
  this.TipStrucnogUsavrsavanjaNaziv = input.TipStrucnogUsavrsavanja;
  this.Naziv = input.Naziv;
  this.Predavac = input.Predavac;
  this.Trajanje = input.Trajanje;
  this.Datum = input.Datum;
  this.RealizovanOdDatuma = input.RealizovanOdDatuma;
  this.RealizovanDoDatuma = input.RealizovanDoDatuma;
  this.BrojBodova = input.BrojBodova;
  this.KataloskiBroj = input.KataloskiBroj;
  this.Mesto = input.Mesto;
  this.USvojstvuPredavaca = input.USvojstvuPredavaca;
  this.Obavezno = input.Obavezno;

  return this;
}

Serialize(input: StrucnoUsavrsavanjeView){
    return input;
}
}